import axios from "axios";

const getFootballTournaments = async () => {
    const response = await axios.get('/api/football-widget/get-tournaments');
    return response.data;
};

const getFootballRounds = async () => {
    const response = await axios.get('/api/football-widget/get-rounds');
    return response.data;
};

const getFootballWidgetList = async (filters, page, records) => {
    const payload = { filters, page, records };
    const response = await axios.post('/api/football-widget/list', payload);
    return response.data;
};

const getAllClients = async () => {
    const response = await axios.get('/api/football-widget/get-client-names');
    return response.data;
};

const getConfigSchema = async () => {
    const response = await axios.get('/api/football-widget/get-config-schema');
    return response.data;
};

const createFootballWidget = async (widgetData) => {
    const response = await axios.post('/api/football-widget/create', widgetData);
    return response.data;
};

const getFootballWidgetDetails = async (id) => {
    const response = await axios.get(`/api/football-widget/details/${id}`);
    return response.data;
};

const updateFootballWidget = async (id, widgetData) => {
    const response = await axios.post(`/api/football-widget/update/${id}`, widgetData);
    return response.data;
};

const getMatchesByTournament = async (tournamentSlug) => {
    const response = await axios.get(`/api/football-widget/matches-by-tournament/${tournamentSlug}`);
    return response.data;
};

const deleteWidget = async (payload) => {
    const response = await axios.post(`/api/football-widget/delete`, payload);
    return response.data;
};


const getMatches = async () => {
    const response = await axios.get('/api/football-widget/recent-matches');
    return response.data;
};

const getRecentTournaments = async () => {
    const response = await axios.get('/api/football-widget/recent-tournaments');
    return response.data;
};

const getWidgetPreview = async (widgetData) => {
    try {
        const res = await axios.post('/api/football-widget/preview', widgetData, {
            responseType: 'text'
        });
        return { status: true, data: res.data };
    } catch (err) {
        console.error("Preview fetch error:", err);
        return { status: false, msg: "Failed to fetch preview." };
    }
};
const getMatchesBySlugs = async (slugsArray) => {
    if (!slugsArray || slugsArray.length === 0) {
        return { status: true, data: [] };
    }
    const response = await axios.get('/api/football-widget/get-matches-by-slugs', {
        params: {
            slugs: slugsArray.join(','),
        },
    });
    return response.data;
};
const getActiveFilters = async () => {
    const response = await axios.get('/api/football-widget/get-active-filters');
    return response.data;
};
const getMatchesByRound = async (roundSlug) => {
    if (!roundSlug) return { status: false, data: { data: [] } };
    const response = await axios.get(`/api/football-widget/round/${roundSlug}/matches`);
    return response.data;
};

export default {
    getFootballTournaments,
    getFootballRounds,
    getFootballWidgetList,
    getAllClients,
    getConfigSchema,
    createFootballWidget,
    getFootballWidgetDetails,
    updateFootballWidget,
    getMatchesByTournament,
    deleteWidget,
    getMatches,
    getRecentTournaments,
    getWidgetPreview,
    getMatchesBySlugs,
    getActiveFilters,
    getMatchesByRound
};